// src/components/PromptEnhancement.js - Side-by-side layout with one-click selection
import React, { useState, useEffect } from 'react';
import './PromptEnhancement.css';

const PromptEnhancement = ({ isOpen, onClose, originalPrompt, enhancedPrompt, onAccept, isLoading }) => {
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  
  // Reset selection when dialog opens or content changes
  useEffect(() => {
    if (isOpen) {
      setSelectedPrompt(null);
      setShowFeedback(false);
    }
  }, [isOpen, originalPrompt, enhancedPrompt]);
  
  if (!isOpen) return null;
  
  const handleSelectPrompt = (prompt) => {
    setSelectedPrompt(prompt);
    setShowFeedback(true);
    
    // Add a small delay before accepting to show the selection state
    setTimeout(() => {
      onAccept(prompt);
    }, 300); // 300ms delay to show selection state
  };
  
  return (
    <div className="prompt-enhancement-overlay">
      <div className="prompt-enhancement-container">
        <div className="prompt-enhancement-header">
          <h2>Choose a Prompt</h2>
          <button className="prompt-enhancement-close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="prompt-enhancement-content">
          <div className="prompt-enhancement-section">
            <div className="prompt-enhancement-label">
              <h3>Original Prompt</h3>
            </div>
            <div 
              className={`prompt-text ${selectedPrompt === originalPrompt ? 'selected' : ''}`}
              onClick={() => handleSelectPrompt(originalPrompt)}
            >
              {originalPrompt}
            </div>
          </div>
          
          <div className="prompt-enhancement-section">
            <div className="prompt-enhancement-label">
              <h3>Enhanced Prompt</h3>
            </div>
            <div 
              className={`prompt-text ${selectedPrompt === enhancedPrompt ? 'selected' : ''}`}
              onClick={() => isLoading ? null : handleSelectPrompt(enhancedPrompt)}
            >
              {isLoading ? (
                <div className="prompt-loading">
                  <div className="prompt-loading-spinner">
                    <div></div><div></div><div></div><div></div>
                  </div>
                  <p>Generating enhanced prompt...</p>
                </div>
              ) : enhancedPrompt}
            </div>
          </div>
        </div>
        
        <div className="prompt-enhancement-footer">
          {showFeedback && (
            <div className="prompt-feedback">Prompt selected!</div>
          )}
          <button className="prompt-enhancement-cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptEnhancement;